import { Component } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@app/auth/services/auth.service";

@Component({
  selector: "app-email-verified",
  templateUrl: "./email_verified.component.html",
  styleUrls: ["./email_verified.component.scss"],
})
export class EmailVerifiedComponent {

  verifying: boolean = true;
  errorMsg: string = "";

  constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
  ) {}

  ngOnInit() {
    this.verifyEmail();
  }

  verifyEmail() {
    const { recordId, confirmationToken } = this.route.snapshot.params;
    if (recordId && confirmationToken) {
      this.authService
      .verifyEmail(recordId, confirmationToken)
      .subscribe({
        next: this.handleSuccessResponse.bind(this),
        error: this.handleErrorResponse.bind(this)
     });
    }
  }

  private handleSuccessResponse(response) {
    this.verifying = false;
    if (!response.ok) {
      this.errorMsg = "Something went wrong.";
    }
  }

  private handleErrorResponse(response) {
    this.verifying = false;
    this.errorMsg = "Something went wrong.";
  }
}
